<template>
    <div>
        <!-- import account -->
        <app-account></app-account>

        <div class="container">
            <!-- Alert Messages -->
            <dl v-if="msg !== ''" class="row mt-3 mb-n3">
                <dd class="col-12">
                    <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                        <i class="fas fa-exclamation-circle"></i> {{ msg }}
                    </div>
                </dd>
            </dl>
            <form v-if="selectedItem">
                <!-- stage heading -->
                <div class="row mt-5">
                    <div class="col-lg-6 col-md-4 col-12">
                        <h3 class="small-text">Modify Your Item</h3>
                    </div>
                    <div class="col-lg-6 col-md-8 col-12">
                        <div class="row">
                            <div v-if="!modifyItem.active" class="col-md-4 col-sm-12 col-12 mb-2">
                                <button @click.prevent="unhideItemFxn" class="loadn btn btn-danger btn-sm form-control">
                                    <i class="far fa-eye-slash"></i> Hidden
                                </button>
                            </div>
                            <div v-else class="col-md-4 col-sm-12 col-12 mb-2">&nbsp;</div>

                            <div class="col-md-4 col-sm-6 col-6">
                                <button v-if="!modifyItem.promoted" @click.prevent="showPromotion = true" class="btn btn-warning btn-sm form-control">
                                    <i class="fas fa-fire"></i> Promote
                                </button>
                                <button v-else @click.prevent="showPromotion = true" class="btn btn-dark text-warning btn-sm form-control">
                                    <i class="fas fa-fire"></i> Promoted
                                </button>
                            </div>

                            <div class="col-md-4 col-sm-6 col-6">
                                <button @click.prevent="showMarkAsSold = true" class="btn btn-dark-green btn-sm form-control">
                                    <i class="fas fa-wallet"></i> Mark as sold
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- preview images -->
                <div class="row my-3">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="form-group">
                                    <label for="itemTitle">Item Title:</label>
                                    <input v-model="title" type="text" class="form-control no-lines" id="itemTitle" placeholder="|">
                                </div>
                                <div class="form-group">
                                    <label for="itemDescription">Item Description:</label>
                                    <textarea v-model="description" type="text" class="form-control no-lines" id="itemDescription" rows="5" placeholder="|"></textarea>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-sm-12">
                                        <div class="fom-group">
                                            <label for="itemCategory">Item Category:</label>
                                            <select v-model="category" class="custom-select no-lines" id="itemCategory" style="border-color: #DFDFDF;">
                                                <option selected disabled value="">-select-</option>
                                                <option v-for="(obj, i) in theCategories" :key="i" :value="obj.category">
                                                    {{obj.category}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="fom-group mt-sm-3 mt-md-0">
                                            <label for="itemCategory">Item Sub-Category:</label>
                                            <select v-model="subCategory" class="custom-select no-lines" id="itemCategory" style="border-color: #DFDFDF;">
                                                <option selected disabled value="">-select-</option>
                                                <option v-for="(x, i) in theSubCategories" :key="i" :value="x.subCategory">
                                                    {{x.subCategory}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="fom-group mt-3">
                                    <label for="itemCategory">Item Condition:</label>
                                    <select v-model="condition" class="custom-select no-lines" id="itemCategory" style="border-color: #DFDFDF;">
                                        <option selected disabled value="">-select-</option>
                                        <option v-for="(obj, i) in theConditions" :key="i" :value="obj.condition">
                                            {{obj.condition}}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group mt-3">
                                    <label for="itemReferenceUrl">Item Ref. URL (optional):</label>
                                    <input v-model="refUrl" type="text" class="form-control no-lines" id="itemReferenceUrl" placeholder="|">
                                </div>
                                <div class="form-group mt-3">
                                    <label for="itemPrice">Item Price:</label>
                                    <div class="input-group">
                                        <input type="number" v-model="price" class="form-control no-lines" id="itemPrice">
                                        <div class="input-group-append">
                                            <div class="input-group-text bg-light text-uppercase">
                                                {{user.currency}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <span class="mr-3">This item will be</span>
                                    <input v-model="priceType" type="radio" name="priceTypeRadio" id="negotiable" value="negotiable"> 
                                    <label for="negotiable" class="mx-2">Negotiable</label> 
                                    <input v-model="priceType" type="radio" name="priceTypeRadio" id="nonNegotiable" value="non-negotiable"> 
                                    <label for="nonNegotiable" class="mx-2">Non-Negotiable</label>
                                    <input v-model="priceType" type="radio" name="priceTypeRadio" id="forDonation" value="donation"> 
                                    <label for="forDonation" class="mx-2">For Donation (free)</label>
                                </div>
                                <!-- show item photos -->
                                <app-modify-item-photos :photos="updatedPhotosArr" :itemId="modifyItem._id"></app-modify-item-photos>

                                <!-- save changes -->
                                <hr>
                                <div class="row mt-3">
                                    <div class="col-lg-8 col-12">
                                        <p class="text-danger">
                                            <span @click="showAdvanced = !showAdvanced" class="clickable"><i class="fas fa-cogs"></i> Advanced Settings</span>
                                        </p>
                                        <div v-if="showAdvanced">
                                            <p v-if="modifyItem.active">
                                                <i class="far fa-eye"></i>
                                                <span @click="hideItemFxn" class="mx-2 clickable">Hide this item temporarily (make unavailable to the public)</span> 
                                            </p>
                                            <p v-else>
                                                <i class="far fa-eye-slash"></i>
                                                <span @click="unhideItemFxn" class="mx-2 text-danger clickable">Item is hidden. Click to unhide (make available to the public)</span> 
                                            </p>
                                            <p>
                                                <i class="fas fa-trash-alt"></i>
                                                <span @click="removeItemFxn" class="mx-2 text-danger clickable">Delete Item (item will be permanently removed)</span> 
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 offset-lg-0 col-md-5 offset-md-7 col-12">
                                        <div class="row">
                                            <div class="col-5">
                                                <router-link :to="{ name: 'selling' }" class="btn btn-light bg-silver btn-sm form-control">Close</router-link>
                                            </div>
                                            <div class="col-7">
                                                <button @click.prevent="saveChanges" class="loadn btn btn-dark-green btn-sm form-control">Save Changes</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer text-dark-green text-center">
                                <span>Note: Being very descriptive about your item increases its chances of being seen by many potential buyers!</span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <!-- import sub-categories here -->
        <app-sub-categories :categoryName="category"></app-sub-categories>
        
        <!-- show mark item as sold -->
        <app-mark-as-sold v-if="showMarkAsSold" :itemId="modifyItem._id"></app-mark-as-sold>
        
        <!-- show promotions -->
        <app-promotions :key="forceReloadKey" v-if="showPromotion" :itemId="modifyItem._id"></app-promotions>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

import Account from '../../shared/Account.vue'
import MarkAsSold from './MarkAsSold.vue'
import LayoutUser from '@/layouts/User.vue'
import ModifyItemPhotos from './ModifyItemPhotos.vue'
import Promotions from '../../shared/Promotions.vue'
import SubCategories from '@/components/general/shared/ItemParts/SubCategories.vue'

export default {
    name: "ModifyItem",
    data() {
        return {
            title: '',
            description: '',
            category: '',
            subCategory: '',
            condition: '',
            refUrl: '',
            price: '',
            priceType: '',
            msg: '',
            color: 'danger',
            showMarkAsSold: false,
            showPromotion: false,
            showAdvanced: false,
            forceReloadKey: 0
        }
    },
    methods: {
        ...mapActions(['saveModifiedItem', 'footerFixed', 'hideItem', 'unhideItem', 'removeItem', 'listPostedItem', 'modifyItemObj']),
        updatePage(newItemId){
            this.listPostedItem(newItemId)
            .then((data) => {
                this.modifyItemObj(data.result).then(() => {}).catch((e) => {})
            })
            .catch((e) => {})
        },
        assignValues() {
            if(this.modifyItem.title){ this.title = this.modifyItem.title }
            if(this.modifyItem.description){ this.description = this.modifyItem.description }
            if(this.modifyItem.category){ this.category = this.modifyItem.category }
            if(this.modifyItem.subCategory){ this.subCategory = this.modifyItem.subCategory }
            if(this.modifyItem.condition){ this.condition = this.modifyItem.condition }
            if(this.modifyItem.refUrl){ this.refUrl = this.modifyItem.refUrl }
            if(this.modifyItem.price){ this.price = this.modifyItem.price }
            if(this.modifyItem.active){ this.active = this.modifyItem.active }
            this.itemPriceType() // get the current item priceType donation, negotiable or not
        },
        promotionPage() {
            // check if payment gateway sent query data
            if(this.$route.query.status && this.$route.query.tx_ref){
                this.showPromotion = true
            }
        },
        saveChanges() {
            this.color = "danger"
            if(this.title === ''){ this.msg = "Adding a title makes your item most visible to buyers"; return }
            if(this.description === ''){ this.msg = "Entering a clear description increases your chances of selling sooner"; return }
            if(this.category === ''){ this.msg = "Select any category you think best describes this item"; return }
            if(this.condition === ''){ this.msg = "Select the appropriate condition of this item"; return }
            if(this.price === ''){ this.msg = "Enter the cost price of this item even if its to be donated"; return }
            if(this.priceType === ''){ this.msg = "Specify if this item is negotiable, non-negotiable or for donation"; return }
            // add properties to build Item object 
            let itemObj = {
                userId: this.user._id,
                itemId: this.modifyItem._id,
                title: this.title,
                description: this.description,
                category: this.category,
                subCategory: this.subCategory,
                condition: this.condition,
                refUrl: this.refUrl,
                price: this.price,
                photos: this.updatedPhotosArr ? this.updatedPhotosArr : [],
                deletePhotos: this.deletePhotosArr ? this.deletePhotosArr : [],
            }
            // check the price type negotiable, non-negotiable and for donation and process accordingly
            if(this.priceType === "donation"){ 
                itemObj.firmPrice = true 
                itemObj.donation = true 
            }
            else if(this.priceType === "negotiable"){ 
                itemObj.firmPrice = false
                itemObj.donation = false 
            }
            else {
                itemObj.firmPrice = true
                itemObj.donation = false 
            }
            this.saveModifiedItem(itemObj)
            .then((data) => {
                if(!data.error){ this.color = "success" }
                this.msg = data.msg
            })
            .catch((e) => {
                this.msg = "Saving your modifications failed, do try again."
            })
        },
        itemPriceType() {
            if(this.modifyItem.donation){
                return this.priceType = "donation"
            }
            else if(this.modifyItem.firmPrice){
                return this.priceType = "non-negotiable"
            }
            else {
                return this.priceType = "negotiable"
            }
        },
        hideItemFxn() {
            if(this.selectedItem){
                this.color = "danger"
                let itemObj = {
                    itemId: this.modifyItem._id,
                    userId: this.user._id
                }
                this.hideItem(itemObj)
                .then((data) => {
                    this.color = !data.error ? "success" : "danger",
                    this.msg = data.msg
                })
                .catch((e) => {})
            }
        },
        unhideItemFxn() {
            if(this.selectedItem){
                this.color = "danger"
                let itemObj = {
                    itemId: this.modifyItem._id,
                    userId: this.user._id
                }
                this.unhideItem(itemObj)
                .then((data) => {
                    this.color = !data.error ? "success" : "danger",
                    this.msg = data.msg
                })
                .catch((e) => {})
            }
        },
        removeItemFxn() {
            if(this.selectedItem){
                this.color = "danger"
                let itemObj = {
                    itemId: this.modifyItem._id,
                    userId: this.user._id
                }
                // vuejs-dialog usage for pop up confirmations
                // https://github.com/Godofbrowser/vuejs-dialog
                let message = "<center>This item will be permanently deleted! Do you want to proceed ?</center>";
                let options = {
                    html: true, 
                    okText: 'Yes, Proceed',
                    cancelText: 'Cancel',
                    animation: 'bounce', // Available: "zoom", "bounce", "fade"
                }
                this.$dialog.confirm(message, options)
                .then((dialog) => {
                    this.removeItem(itemObj)
                    .then((data) => {
                        this.color = !data.error ? "success" : "danger",
                        this.msg = data.msg
                        // redirect back to selling page
                        if(!data.error){
                            this.$router.push({
                                name: 'selling'
                            }).catch((e) => {})
                        }
                    })
                    .catch((e) => {})
                })
                .catch((e) => {})
            }
        },
    },
    computed: {
        ...mapGetters(['user', 'modifyItem', 'setCategories', 'setSubCategories', 'setConditions']),
        selectedItem() {
            if(this.modifyItem && this.modifyItem !== null){
                this.assignValues()
                this.promotionPage()
                return true
            }
            return false
        },
        updatedPhotosArr() {
            if(this.modifyItem && this.modifyItem.photos && this.modifyItem.photos.length > 0) {
                return this.modifyItem.photos
            }
        },
        deletePhotosArr() {
            if(this.modifyItem && this.modifyItem.deletePhotos && this.modifyItem.deletePhotos.length > 0) {
                return this.modifyItem.deletePhotos
            }
            return false
        },
        theCategories(){
            if(this.setCategories && this.setCategories.length){
                return this.setCategories
            }
            return [] 
        },
        theSubCategories(){
            if(this.setSubCategories && this.setSubCategories.length){
                return this.setSubCategories
            }
            return [] 
        },
        theConditions(){
            if(this.setConditions && this.setConditions.length){
                return this.setConditions
            }
            return []
        },
    },
    components: {
        appAccount: Account,
        appMarkAsSold: MarkAsSold,
        appModifyItemPhotos: ModifyItemPhotos,
        appSubCategories: SubCategories,
        appPromotions: Promotions
    },
    watch: {
        modifyItem() {
            this.forceReloadKey += 1
        },
        $route() {
            this.updatePage(this.$route.params.id)
        }
    },
    created() {
        this.updatePage(this.$route.params.id)
        eventBus.$on('hideGhostMode', (value) => {
            this.showMarkAsSold = value
            this.showPromotion = value
        })
        this.$emit('update:layout', LayoutUser);
        this.footerFixed(false)
    }
}
</script>